import React from 'react';
import { SimpleEffectPropsContainer } from '@/components/simple-effect-props-container';
import { useLocaleStore } from '@/i18n';
import { type WidgetCommonProps } from '../../../types';
import { TextColorPicker } from '../../text-color-picker';

type Props = WidgetCommonProps;

export const FillInspector: React.FC<Props> = (props) => {
    const { $t } = useLocaleStore();

    return (
        <SimpleEffectPropsContainer title={$t((v) => v.textStyleAdd.fillOrGradient)}>
            <div className="text-fill-inspector">
                {/* 填充色 */}
                <TextColorPicker useForFill size={{ width: 34, height: 34 }} panelPosition="shortcut" {...props} />
            </div>
        </SimpleEffectPropsContainer>
    );
};
